import type {Values} from "@wix/devzai-utils-common";

export const DoppeActionTypeRenderingInPageSupport = {
    FullyEnabled: true,
    Disabled: false,
    AsCardOnly: 'AsCardOnly'
} as const;
export type DoppeActionTypeRenderingInPageSupport = Values<typeof DoppeActionTypeRenderingInPageSupport>;